<template>
    <div class="container">
        <span>综合收款统计</span>
        <div class="search-box">
            <span style=" font-size: 14px;margin-right: 10px;">统计周期:</span>
            <div class="type-box">
                <span :class="type === 'day' ? 'active' : ''" @click="changeDate('day')">按日</span>
                <span :class="type === 'monthrange' ? 'active' : ''" @click="changeDate('monthrange')"> 按月</span>
                <span :class="type === 'daterange' ? 'active' : ''" @click="changeDate('daterange')">自定义</span>
            </div>
            <span style=" font-size: 14px;margin-right: 10px;">营业周期:</span>
            <el-date-picker v-model="dataTime" :type="type === 'day' ? 'daterange' : type" :format="format"
                :placeholder="placeholder" :picker-options="pickerOptions">
            </el-date-picker>
            <el-button type="primary" icon="el-icon-search"
                style="margin-left: 20px;background-color: #f59a23;border: none;" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh" style="margin-left: 20px;" @click="reset">重置</el-button>
        </div>
        <el-table :data="tableData" style="width: 98%" border :summary-method="getSummaries" show-summary>
            <el-table-column type="index" width="160" label="序号" align="center">
            </el-table-column>
            <el-table-column prop="timeStr" label="营业时间" align="center"></el-table-column>
            <el-table-column prop="payType" label="业务大类" align="center"></el-table-column>
            <el-table-column sortable prop="businessAmount" label="收款小计" align="center"></el-table-column>

            <el-table-column prop="cashPaid" label="现金" align="center"></el-table-column>
            <el-table-column prop="aliPaid" label="支付宝" align="center"></el-table-column>
            <el-table-column prop="wechatPaid" label="微信" align="center"></el-table-column>
            <el-table-column prop="creditCardPaid" label="信用卡" align="center"></el-table-column>
            <el-table-column prop="memberCardPaid" label="会员卡" align="center"></el-table-column>
            <el-table-column prop="chequePaid" label="支票" align="center"></el-table-column>
            <el-table-column prop="otherPaid" label="其他" align="center"></el-table-column>
        </el-table>
    </div>
</template>

<script>
import moment from 'moment/moment';
// 创建一个表示当前日期的 Date 对象
let currentDate = new Date();

// 获取当前日期的天数
let currentDay = currentDate.getDate();

// 将日期减去一天
currentDate.setDate(currentDay - 1);
export default {
    name: '',
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() >= today.getTime();
                }
            },
            type: 'monthrange',
            dataTime: [currentDate, currentDate],
            format: 'yyyy-MM',
            vformat: 'yyyy-MM',
            placeholder: '选择月',
            active: 0,
            dateTime: [],
            tableData: [],
            queryInfo: {
                condition: {
                },
                currPage: 1,
                pageCount: 1,
                pageSize: 10,
            },
            options: [],
            areaOptions: [],
            total: 0,
            loading: false
        };
    },
    created() {
        this.getData()
    },
    methods: {
        search() {
            this.getData()
        },
        reset() {
            //moment.js 格式化时间
            this.dataTime = [currentDate, currentDate]
            this.getData()
        },
        changeDate(type) {
            //moment.js 格式化时间
            this.dataTime = [currentDate, currentDate]
            if (type === 'day') {
                this.format = 'yyyy-MM-dd';
                this.vformat = 'YYYY-MM-DD';
                this.placeholder = '选择日期范围';
            } else if (type === 'monthrange') {
                this.format = 'yyyy-MM';
                this.vformat = 'YYYY-MM';
                this.placeholder = '选择月';
            } else if (type === 'daterange') {
                this.format = 'yyyy-MM-dd';
                this.vformat = 'YYYY-MM-DD';
                this.placeholder = '选择日期范围';
            }
            this.type = type;
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = sums[index].toFixed(2);
                    //sums[index] += ' 元';
                } else {
                    sums[index] = '--';
                }
            });

            return sums;
        },
        async getData() {
            this.queryInfo.condition = {}
            let timeType = this.type === 'day' ? 1 : this.type === 'monthrange' ? 2 : 3
            let startTime = null
            let endTime = null
            if (this.dataTime != null && this.dataTime.length > 0) {
                startTime = moment(this.dataTime[0]).format(this.vformat)
                endTime = moment(this.dataTime[1]).format(this.vformat)
            } else {
                this.$message.error('请选择时间范围')
                return
            }
            this.queryInfo.condition.merchantCode = localStorage.getItem('merchantCode')
            this.queryInfo.condition.type = timeType
            this.queryInfo.condition.startTime = startTime
            this.queryInfo.condition.endTime = endTime
            this.loading = true
            let res = await this.$http.post('/businessOverview/comprehensivePayStatistics', this.queryInfo)
            if (res.data.code == 200) {
                this.total = res.data.data.count;
                this.queryInfo.currPage = res.data.data.currPage;
                this.tableData = res.data.data.data.map(item => {
                    if (item.timeStr === '') {
                        item.timeStr = '--'
                    }
                    return item
                }

                );
                this.loading = false
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    padding: 20px;
}


.search-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 20px;



    .type-box {
        display: flex;
        align-items: center;
        margin-right: 20px;
        justify-content: flex-start;

        span {
            padding: 0 10px;
            cursor: pointer;
            color: #333;
            border: 1px solid #cecece;
            font-size: 14px;
        }

        .active {
            color: #f59a23;
            border: 1px solid #f59a23;
        }
    }
}
</style>